import React, { useState } from 'react';
import Image from '../../../components/AppImage';

const ClientLogoBar = () => {
  const [hoveredClient, setHoveredClient] = useState(null);

  const clients = [
    {
      id: 1,
      name: 'Ford Motor Company',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/3/3e/Ford_logo_flat.svg',
      implementation: 'Code Conversion Tools',
      results: 'Enabled automated code transformation and modernization'
    },
    {
      id: 2,
      name: 'Siemens Technology',
      logo: '/assets/images/Siemens-logo.png',
      implementation: 'Secure On-Prem MCP Compliant Agent',
      results: 'Code generation with enterprise security compliance'
    },
    {
      id: 3,
      name: 'Citibank',
      logo: '/assets/images/Citibank-logo.png',
      implementation: 'AI Tools Development',
      results: 'Custom AI solutions for financial services'
    },
    {
      id: 4,
      name: 'Point32Health',
      logo: '/assets/images/Point32Health-logo.png',
      implementation: 'AI Gateways & Custom Library',
      results: 'AI-enabled healthcare infrastructure and tools'
    },
    {
      id: 5,
      name: 'DIEXTRA',
      logo: '/assets/images/dietra_logo.png',
      implementation: 'Healthcare AI Application',
      results: 'AI-powered platform for patient management and insights'
    },
    {
      id: 6,
      name: 'HCL',
      logo: '/assets/images/HCL-logo.png',
      implementation: 'Enterprise AI Engineering',
      results: 'Delivered AI components and integrations for large-scale programs'
    },
    {
      id: 7,
      name: 'Goodleaf',
      logo: '/assets/images/GoodLeaf-logo.webp',
      implementation: 'Data & AI Enablement',
      results: 'Set up analytics-ready data and AI workflows'
    },
    {
      id: 8,
      name: 'Norterra',
      logo: '/assets/images/Norterra-logo.png',
      implementation: 'Data & AI Enablement',
      results: 'Set up analytics-ready data and AI workflows'
    }
  ];

  return (
    <section className="py-16 blue-radial-bg text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">

        {/* Client Logos */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {clients?.map((client) => (
            <div
              key={client?.id}
              className="relative group"
              onMouseEnter={() => setHoveredClient(client?.id)}
              onMouseLeave={() => setHoveredClient(null)}
            >
              {/* Logo Container */}
              <div className="glass-card p-6 enterprise-transition group-hover:shadow-md group-hover:-translate-y-1">
                <div className="aspect-[2/1] flex items-center justify-center">
                  <Image
                    src={client?.logo}
                    alt={`${client?.name} logo`}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              </div>

              {/* Hover Details */}
              {hoveredClient === client?.id && (
                <div className="absolute top-full left-0 right-0 mt-2 glass-tooltip p-4 z-10 animate-in fade-in slide-in-from-top-2 duration-200">
                  <h3 className="font-semibold text-white mb-1">
                    {client?.name}
                  </h3>
                  <p className="text-sm text-blue-300 font-medium mb-2">
                    {client?.implementation}
                  </p>
                  <p className="text-xs text-white/80">
                    {client?.results}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-12 pt-8 border-t border-white/20">
          <div className="flex flex-wrap justify-center items-center gap-8 text-sm text-white/70">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-success rounded-full"></div>
              <span>SOC 2 Type II Certified</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-success rounded-full"></div>
              <span>ISO 27001 Compliant</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-success rounded-full"></div>
              <span>GDPR & HIPAA Ready</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-success rounded-full"></div>
              <span>99.9% Uptime SLA</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogoBar;